/* display loader while the app is fetching data from backend */
const Loading = () => {

    return(
        <div className="loading-container">
            <div className="loading-outer">
                <div className="loading-inner"></div>
            </div>
            <h2>Loading data ...</h2>
        </div>
    );
}

export default Loading;